export default function CreditsSection() {
  return (
    <div className="flex flex-col items-center justify-center w-full font-light text-white text-xxs h-14 content bg-secondary font-poppins tablet2:text-xs">
      <p className="text-center">
        2024 - Edan Contabilidade - Todos os direitos reservados - Website
        desenvolvido por Paper Street Softwares
      </p>
    </div>
  );
}
